import { Badge } from '@bbpos/ui';
import type { SalesInvoiceStatus } from './types';

type BadgeVariant = 'outstanding' | 'partiallyPaid' | 'paid' | 'cancelled';

const STATUS_MAP: Record<SalesInvoiceStatus, { label: string; variant: BadgeVariant }> = {
  OPEN: { label: 'Open', variant: 'outstanding' },
  PARTIALLY_PAID: { label: 'Partially paid', variant: 'partiallyPaid' },
  PAID: { label: 'Paid', variant: 'paid' },
  CANCELLED: { label: 'Cancelled', variant: 'cancelled' },
};

export function SalesInvoiceStatusBadge({ status, size = 'sm' }: { status: SalesInvoiceStatus; size?: 'sm' | 'md' }) {
  const meta = STATUS_MAP[status] ?? STATUS_MAP.OPEN;
  return (
    <Badge variant={meta.variant} size={size}>
      <span className="flex items-center gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-current" />
        {meta.label}
      </span>
    </Badge>
  );
}
